module.exports = __webpack_public_path__ + "files/d9c4d4cb353a2bcafe7de11e9750be84.png";